export const questionType = {
	single: 0,
	group: 1,
}
export const questionTypes = [
	{ id: 0, name: 'سؤال مستقل' },
	{ id: 1, name: 'أسئلة مترابطة' },
]

export const questionDifficulty = {
	easy: 1,
	medium: 2,
	hard: 3,
}

export const questionDifficulties = [
	{ id: 0, name: 'سهل' },
	{ id: 1, name: 'متوسط' },
	{ id: 2, name: 'صعب' },
]

export const subContentType = {
	question: 0,
	divider: 1,
	text: 2,
	image: 3,
}

export const examStatus = {
	new: 1,
	inProgress: 2,
	done: 3,
}
export const examStatuses = [
	{ id: 1, name: 'جديد' },
	{ id: 2, name: 'قيد التنفيذ' },
	{ id: 3, name: 'انتهى' },
]
export const gradeViewType = {
	number: 0,
	percentage: 1,
	symbol: 2
}